import React, { useState } from "react";
import { Footer, Navbar } from "../components";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useCurrency } from "../context/CurrencyContext";
import { WHATSAPP_PHONE } from "../config";
import { toAnalyticsItem, trackEvent } from "../lib/analytics";

const Checkout = () => {
  const state = useSelector((state) => state.handleCart);
  const { currency, formatPrice } = useCurrency();
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    address: "",
    notes: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const EmptyCart = () => {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12 py-5 bg-light text-center">
            <h4 className="p-3 display-5">No hay programas en el carrito</h4>
            <Link to="/" className="btn btn-outline-dark mx-4">
              <i className="fa fa-arrow-left"></i> Seguir comprando
            </Link>
          </div>
        </div>
      </div>
    );
  };

  const ShowCheckout = () => {
    let subtotal = 0;
    let shipping = 0.0;
    let totalItems = 0;
    state.map((item) => {
      return (subtotal += item.price * item.qty);
    });

    state.map((item) => {
      return (totalItems += item.qty);
    });

    const pageUrl = typeof window !== "undefined" ? window.location.href : "";
    const whatsappMessage = [
      "A1 Pro - Pedido por WhatsApp",
      "",
      `Nombre: ${form.name}`,
      `Email: ${form.email}`,
      `Telefono: ${form.phone}`,
      `Ciudad: ${form.city}`,
      `Direccion: ${form.address}`,
      `Notas: ${form.notes || "-"}`,
      "",
      "Resumen:",
      ...state.map((item) => `- ${item.title} x${item.qty} (${formatPrice(item.price)})`),
      "",
      `Total productos: ${totalItems}`,
      `Moneda: ${currency}`,
      `Total: ${formatPrice(subtotal + shipping)}`,
      `URL: ${pageUrl}`,
    ].join("\n");
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(
      whatsappMessage
    )}`;
    const checkoutPayload = {
      currency,
      value: Number(subtotal + shipping || 0),
      items: state.map((item) => toAnalyticsItem(item, item.qty)),
      item_count: Number(totalItems || 0),
    };

    const handleSubmit = (event) => {
      event.preventDefault();
      trackEvent("add_payment_info", {
        ...checkoutPayload,
        payment_type: "whatsapp",
      });
      trackEvent("whatsapp_checkout", {
        ...checkoutPayload,
        source: "checkout_form",
      });
      window.open(whatsappUrl, "_blank", "noopener,noreferrer");
    };

    return (
      <>
        <div className="container py-5">
          <div className="row my-4">
            <div className="col-md-5 col-lg-4 order-md-last">
              <div className="card mb-4">
                <div className="card-header py-3 bg-light">
                  <h5 className="mb-0">Resumen de compra</h5>
                </div>
                <div className="card-body">
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0">
                      Programas ({totalItems})<span>{formatPrice(subtotal)}</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                      Acceso digital
                      <span>{formatPrice(shipping)}</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 mb-3">
                      <div>
                        <strong>Total</strong>
                      </div>
                      <span>
                        <strong>{formatPrice(subtotal + shipping)}</strong>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="card mb-4">
                <div className="card-header py-3 bg-light">
                  <h5 className="mb-0">Resumen de productos</h5>
                </div>
                <div className="card-body">
                  {state.map((item) => (
                    <div key={item.id} className="d-flex align-items-center mb-3">
                      <img
                        src={item.image}
                        alt={item.title}
                        width={64}
                        height={48}
                        style={{ objectFit: "cover", borderRadius: "6px" }}
                      />
                      <div className="ms-3">
                        <strong>{item.title}</strong>
                        <div className="text-muted">
                          {item.qty} x {formatPrice(item.price)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-8">
              <div className="card mb-4">
                <div className="card-header py-3">
                  <h4 className="mb-0">Pago por WhatsApp</h4>
                </div>
                <div className="card-body">
                  <form className="needs-validation" noValidate onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-12">
                        <label htmlFor="name" className="form-label">
                          Nombre completo
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          value={form.name}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-12">
                        <label htmlFor="email" className="form-label">
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          value={form.email}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-12">
                        <label htmlFor="phone" className="form-label">
                          Telefono
                        </label>
                        <input
                          type="tel"
                          className="form-control"
                          id="phone"
                          name="phone"
                          value={form.phone}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="city" className="form-label">
                          Ciudad
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="city"
                          name="city"
                          value={form.city}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="address" className="form-label">
                          Direccion
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="address"
                          name="address"
                          value={form.address}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-12">
                        <label htmlFor="notes" className="form-label">
                          Notas o referencia
                        </label>
                        <textarea
                          className="form-control"
                          id="notes"
                          name="notes"
                          rows="3"
                          value={form.notes}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <hr className="my-4" />

                    <button className="w-100 btn btn-whatsapp" type="submit">
                      Enviar pedido por WhatsApp
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center" data-aos="fade-up">
          Pago
        </h1>
        <hr />
        {state.length ? <ShowCheckout /> : <EmptyCart />}
      </div>
      <Footer />
    </>
  );
};

export default Checkout;
